export const logoLists = [
  {
    title: "长鑫存储",
    logo: "//files.authing.co/authing-website/home-0830-logo-11-k.png",
  },
  {
    title: "招商银行",
    logo: "//files.authing.co/authing-website/home-0830-logo-5-k.png",
  },
  {
    title: "知乎",
    logo: "//files.authing.co/authing-website/banner-logo-zhihu.png",
  },
  {
    title: "可口可乐",
    logo: "//files.authing.co/authing-website/home-0830-logo-12-k.png",
  },
  {
    title: "CSDN",
    logo: "//files.authing.co/authing-website/banner-logo-csdn.png",
  },
  {
    title: "元气森林",
    logo: "//files.authing.co/authing-website/home-0830-logo-9-k.png",
    clickUrl: "https://www.authing.cn/customer/yuanqi",
  },
  {
    title: "PingCAP",
    logo: "//files.authing.co/authing-website/home-0830-logo-8-k.png",
    clickUrl: "https://www.authing.cn/customer/pingcap",
  },
  {
    title: "富途牛牛",
    logo: "//files.authing.co/authing-website/banner-logo-futu.png",
  },
  {
    title: "仙工智能",
    logo: "//files.authing.co/authing-website/banner-logo-seer.png",
  },
  {
    title: "东南大学",
    logo: "//files.authing.co/authing-website/home-0830-logo-3-k.png",
    clickUrl: "https://www.authing.cn/customer/southeast-university",
  },
  {
    title: "保时捷",
    logo: "//files.authing.co/authing-website/home-logo-baoshijie.png",
    clickUrl: "https://www.authing.cn/customer/bentley-motors",
  },
  {
    title: "海底捞",
    logo: "//files.authing.co/authing-website/home-0830-logo-19-k.png",
  },
  {
    title: "复星集团",
    logo: "//files.authing.co/authing-website/home-logo-fuxing.png",
  },
  {
    title: "xrspace",
    logo: "//files.authing.co/authing-website/home-logo-xrspace.png",
  },
];
